function getCellColor(value: number): string {
  if (value >= 70) return "bg-green-500 text-white";
  if (value >= 50) return "bg-yellow-200";
  return "bg-gray-200 text-gray-400";
}

interface ValueArchetypeHeatmapProps {
  categoryScores?: any;
  onUpgrade?: () => void;
}

export function ValueArchetypeHeatmap({
  categoryScores = {},
}: ValueArchetypeHeatmapProps) {
  const archetypeLabels = [
    "Jaguar",
    "Cóndor",
    "Llama",
    "Quetzal",
    "Colibrí",
    "Coquí",
    "Búho",
  ];

  const NewArchetypeLabels = [
    "jaguar",
    "condor",
    "llama",
    "quetzal",
    "colibri",
    "coqui",
    "buho",
  ];

  const ValueArray: { [key: string]: string } = {
    family: "Familia",
    group_loyalty: "Lealtad al grupo",
    humility: "Humildad",
    sacrifice: "Sacrificio",
    respect: "Respeto",
    communication: "Comunicación",
    authority: "Autoridad",
    growth: "Crecimiento",
    cultural_pride: "Orgullo Cultural",
    tenacity_drive: "Tenacidad y empuje",
  };

  const ValueCount = {
    family: 3,
    group_loyalty: 3,
    humility: 3,
    sacrifice: 3,
    respect: 3,
    communication: 3,
    authority: 5,
    growth: 5,
    cultural_pride: 3,
    tenacity_drive: 4,
  };

  // console.log("Value-Archetype Heatmap Scores:", scores);
  // console.log("Value-Archetype Heatmap Category Scores:", categoryScores);

  return (
    <div className="bg-white rounded-lg">
      <h2 className="text-2xl font-bold text-gray-800 mb-4">
        Alineación Valor–Arquetipo
      </h2>

      <div className="overflow-x-auto">
        <table className="min-w-full border rounded-lg text-sm">
          <thead>
            <tr className="bg-gray-50">
              <th className="p-3 text-left font-semibold border-b">Value</th>
              {archetypeLabels.map((label) => (
                <th
                  key={label}
                  className="p-3 text-center font-semibold border-b"
                >
                  {label}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {Object.entries(categoryScores).map(([value, row], rIdx) => (
              <tr key={value} className={rIdx % 2 === 0 ? "bg-gray-50" : ""}>
                <td className="p-3 font-medium border-b">
                  {ValueArray[value.toString()] || value}
                </td>
                {NewArchetypeLabels.map((label) => (
                  <td
                    key={label}
                    className={`p-3 text-center border-b ${getCellColor(
                      ((row as Record<string, number>)[label.toLowerCase()] *
                        100) /
                        (7 * ValueCount[value as keyof typeof ValueCount])
                    )}`}
                  >
                    <span className="font-medium">
                      {Math.min(
                        ((row as Record<string, number>)[label.toLowerCase()] *
                          100) /
                          (ValueCount[value as keyof typeof ValueCount] * 7),
                        100
                      ).toFixed(2)}
                      %
                    </span>
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div className="mt-4 space-y-2">
        <p className="text-sm text-gray-600">
          Este mapa de calor muestra cómo tu arquetipo se alinea con los valores culturales clave latinos. El verde más oscuro indica una alineación más fuerte.
        </p>
        <div className="flex flex-wrap items-center gap-4 text-sm">
          <div className="flex items-center gap-2">
            <div className="w-4 h-4 bg-green-500"></div>
            <span>Fuerte (70-100%)</span>
          </div>
          <div className="flex items-center gap-2">
            <div className="w-4 h-4 bg-yellow-200"></div>
            <span>Moderada (50-69%)</span>
          </div>
          <div className="flex items-center gap-2">
            <div className="w-4 h-4 bg-gray-200"></div>
            <span>Baja (0-49%)</span>
          </div>
        </div>
      </div>
    </div>
  );
  return "";
}
